import {mutate} from "swrv";
import useSwr from "@/core/composables/swr/useSwr";
import {appointmentApi} from "@/container";

const customerAppointmentsKey = (customerId: number) => `customers/${customerId}/appointments?active=true`;

const fetchCustomerAppointments = (customerId: number) => {
    return appointmentApi().customerAppointments(customerId, {active: true});
};

/**
 * SWR composable to fetch the customer active appointments.
 */
const useCustomerAppointments = (customerId: number) => {
    return useSwr(
        customerAppointmentsKey(customerId),
        () => fetchCustomerAppointments(customerId)
    );
};

/**
 * Refetch the customer active appointments for every component reading them,
 * after a change made somewhere else (the agenda grid of the patient file).
 */
export const refreshCustomerAppointments = (customerId: number) => {
    return mutate(customerAppointmentsKey(customerId), fetchCustomerAppointments(customerId));
};

export default useCustomerAppointments;
